export enum MeshViewTargetType
{
    Table = 'mesh-table',
    HeaderCorner = 'mesh-header-corner',
    ColumnHeader = 'mesh-column-header',
    RowHeader = 'mesh-row-header',
    Cell = 'mesh-cell',
}
